module.exports = __webpack_public_path__ + "static/img/erp_logo.e436086.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/erp_logo.png
// module id = Hl9Z
// module chunks = 511